type MediaImage = {
    id: string;
    type: 'image';
    media: Inspire.Image[];
};

type MediaVideoDto = {
    id: string;
    type: 'video';
    media: Inspire.VideoDto[];
};

export type MediaDto = MediaImage | MediaVideoDto;

export enum CollectionStatus {
    PUBLISHED = 'published',
    DECLINED = 'declined',
    MODERATION = 'moderation',
    DRAFT = 'draft',
    LIMITED = 'limited',
}

export interface CollectionFeedStatusDto {
    show_in_feed: boolean;
}

export type CollectionAuthorType = 'user' | 'blogger';

export interface CollectionDto {
    id: string;
    display_name: string;
    number_of_posts: number;
    created_at: string;
    preview_items: Array<MediaDto>;
    modifiable: boolean;
    default_collection: boolean;
    is_public: boolean;
    is_saved: boolean;
    sharing_url: string;
    author?: {
        id: string;
        author_type?: CollectionAuthorType;
        display_name: string;
        avatar_url: Inspire.Image[];
        share_link: string;
    };
    status: CollectionStatus;
    feed_status?: CollectionFeedStatusDto;
    is_liked: boolean;
    likes: number;
    footer_data: {
        feed_button_text: string;
    };
    log_context?: string;
    promote_show_in_feed_available?: boolean;
}

export type MediaVideoModel = {
    id: string;
    type: 'video';
    media: Inspire.Video[];
};

export type MediaModel = MediaImage | MediaVideoModel;

export interface CollectionFeedStatus {
    showInFeed: CollectionFeedStatusDto['show_in_feed'];
}

export interface CollectionModel {
    id: string;
    url: string;
    displayName: string;
    numberOfPosts: number;
    createdAt: string;
    previewItems: MediaModel[];
    modifiable: boolean;
    defaultCollection: boolean;
    isPublic: boolean;
    isSaved: boolean;
    sharingUrl: string;
    author?: {
        id: string;
        displayName: string;
        authorType?: CollectionAuthorType;
        avatarUrl: Inspire.Image[];
        shareLink: string;
    };
    status: CollectionStatus;
    feedStatus?: CollectionFeedStatus;
    isLiked: boolean;
    likes: number;
    footerData?: {
        feedButtonText: string;
    };
    logContext?: string;
    promoteShowInFeedAvailable?: boolean;
}

export type CollectionsDataModel = CollectionModel;

export interface CollectionPersistenceModel {
    id?: string;
    displayName: string;
    isPublic: boolean;
    numberOfPosts?: number;
    feedStatus?: CollectionFeedStatus;
}

export interface CollectionPersistenceDto {
    display_name: string;
    is_public: boolean;
    show_in_feed?: boolean;
}
